import { CHANGE_DISPLAY_MENU } from '@console/store/actionTypes/homepage'

interface IState {
  [key: string]: any
}

const initialState: IState = {}

export default function displayMenu(state = initialState, { type, payload }: any) {
  switch (type) {
    case CHANGE_DISPLAY_MENU:
      if (payload) {
        return { ...state, ...payload }
      }
      return state
    default:
      return state
  }
}
